var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_70_7711",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_70_7711)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#196BFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_if_70_7711)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.3443,
    cy: 59.7708,
    r: 71.2292,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_70_7711)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.3443,
    cy: 59.7708,
    r: 65.75,
    fill: "url(#paint0_radial_70_7711)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_70_7711)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.3443,
    cy: 59.7708,
    r: 64.75,
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60.3443,
    cy: 59.7708,
    r: 61.75,
    stroke: "url(#paint1_linear_70_7711)",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4586 38.833H77.8505C76.5188 34.3554 74.4123 30.064 71.5206 26.1861H27.1286C30.0177 30.064 32.1268 34.3554 33.4586 38.833Z",
    fill: "url(#paint2_linear_70_7711)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8726 51.0259V64.1165H82.2986C84.6544 57.3576 85.1903 50.0893 83.9036 43.0976H34.4737C36.1557 52.2473 34.7204 61.8736 30.1679 70.2072L56.0077 70.0566L72.8753 51.0259H72.8726Z",
    fill: "url(#paint3_linear_70_7711)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7876 86.6309V74.8521L27.2003 74.937L39.7594 94.0937H50.0158H80.1613H80.2011V94.0252L95.0365 68.8298H66.6551L49.7876 86.6309Z",
    fill: "url(#paint4_linear_70_7711)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1286 74.9389L27.1863 74.9361L27.1286 74.8506V74.9389Z",
    fill: "url(#paint5_linear_70_7711)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter3_f_70_7711)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.3985,
    cy: 32.3749,
    r: 24.1083,
    fill: "url(#paint6_linear_70_7711)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_70_7711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3733 100.865C41.2766 117.083 63.6318 120.028 81.165 115.11C126.094 102.508 118.971 48.2645 114.04 37.3062C109.109 26.3478 103.63 50.4562 81.165 76.7562C58.7004 103.056 7.74411 80.5916 26.3733 100.865Z",
    fill: "url(#paint7_linear_70_7711)",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_70_7711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4547 115.658C45.9158 113.101 52.5639 107.22 67.4672 104.152C86.0964 100.317 108.013 96.4812 121.711 65.7979",
    stroke: "url(#paint8_linear_70_7711)",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter6_f_70_7711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4308 99.2615C53.2558 96.4344 58.3504 89.1662 72.1285 82.7094C89.351 74.6385 109.771 65.8015 115.941 32.7709",
    stroke: "url(#paint9_linear_70_7711)",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter7_f_70_7711)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.1818,
    cy: 84.975,
    r: 12.0542,
    fill: "#56FF19"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_if_70_7711",
    x: -28.8849,
    y: -29.4584,
    width: 178.458,
    height: 178.458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_70_7711"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect2_foregroundBlur_70_7711"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_70_7711",
    x: -9.40573,
    y: -9.97919,
    width: 139.5,
    height: 139.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_70_7711"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_70_7711",
    x: -9.40573,
    y: -9.97919,
    width: 139.5,
    height: 139.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_70_7711"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_70_7711",
    x: 36.2901,
    y: -3.7334,
    width: 72.2167,
    height: 72.2167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_70_7711"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_70_7711",
    x: 18.3561,
    y: 30.5962,
    width: 103.343,
    height: 90.6777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_70_7711"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_70_7711",
    x: 39.5865,
    y: 61.3902,
    width: 87.0377,
    height: 58.7642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_70_7711"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_70_7711",
    x: 47.4708,
    y: 28.5872,
    width: 73.4536,
    height: 74.9543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_70_7711"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_70_7711",
    x: 4.12762,
    y: 64.9208,
    width: 40.1083,
    height: 40.1083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_70_7711"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_70_7711",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3443 59.7708) rotate(90) scale(65.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.475962,
    stopColor: "#EDF1F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_70_7711",
    x1: 27.4693,
    y1: 2.82964,
    x2: 97.6026,
    y2: 114.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_70_7711",
    x1: 52.4896,
    y1: 26.1861,
    x2: 52.4896,
    y2: 38.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649038,
    stopColor: "#196BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185CD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_70_7711",
    x1: 57.3765,
    y1: 43.0976,
    x2: 57.3765,
    y2: 70.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649038,
    stopColor: "#196BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185CD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_70_7711",
    x1: 61.1184,
    y1: 68.8298,
    x2: 61.1184,
    y2: 94.0937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649038,
    stopColor: "#196BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185CD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_70_7711",
    x1: 27.1575,
    y1: 74.8506,
    x2: 27.1575,
    y2: 74.9389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649038,
    stopColor: "#196BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185CD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_70_7711",
    x1: 72.3985,
    y1: 8.2666,
    x2: 72.3985,
    y2: 56.4833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#193FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_70_7711",
    x1: 70.0276,
    y1: 34.5962,
    x2: 70.0276,
    y2: 117.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFBFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_70_7711",
    x1: 120.615,
    y1: 64.1541,
    x2: 45.0026,
    y2: 115.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302885,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735577,
    stopColor: "#FFEA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_70_7711",
    x1: 114.493,
    y1: 31.4278,
    x2: 52.9636,
    y2: 99.1338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00EE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302885,
    stopColor: "#FF00EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735577,
    stopColor: "#FF00EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00EE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo11);
export default __webpack_public_path__ + "static/media/logo11.e33fca5d8be78b6b56b710ef21648f40.svg";
export { ForwardRef as ReactComponent };